import { from, of, EMPTY } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap, catchError } from 'rxjs/operators';

import { NotificationHubApiService } from '../../services/notification-hub-api-service';
import { Segment } from '../../services/analytics-services/segment';
import { ALERTS_PANEL_MARKED_ALL_READ, ALERTS_PANEL_MARKED_READ } from '../../constants/analytics-events';
import {
  FETCH_NOTIFICATIONS_REQUEST,
  fetchNotificationsSuccess,
  fetchNotificationsFailure,
  MARK_AS_READ_REQUEST,
  markAsRead,
  MARK_ALL_AS_READ_REQUEST,
  markAllAsRead,
} from './notification-hub.actions';

export const fetchNotificationsEpic = (action$) =>
  action$.pipe(
    ofType(FETCH_NOTIFICATIONS_REQUEST),
    mergeMap(() =>
      from(NotificationHubApiService.getNotifications({ includeDismissed: false })).pipe(
        mergeMap((data) => {
          const notifications = data.notifications.map((n) => {
            let metadata = null;
            if (n.metadataJson) {
              try {
                metadata = JSON.parse(n.metadataJson);
              } catch {
                metadata = null;
              }
            }
            const { metadataJson, ...rest } = n;
            return { ...rest, metadata };
          });
          return of(fetchNotificationsSuccess(notifications, data.unreadCount));
        }),
        catchError(() => of(fetchNotificationsFailure())),
      ),
    ),
  );

export const markAsReadEpic = (action$) =>
  action$.pipe(
    ofType(MARK_AS_READ_REQUEST),
    mergeMap((action) => {
      Segment.trackEvent(ALERTS_PANEL_MARKED_READ, {
        notificationId: action.notificationID,
        checked: true,
      });
      return from(NotificationHubApiService.markAsRead(action.notificationID)).pipe(
        mergeMap(() => of(markAsRead(action.notificationID))),
        catchError(() => EMPTY),
      );
    }),
  );

export const markAllAsReadEpic = (action$) =>
  action$.pipe(
    ofType(MARK_ALL_AS_READ_REQUEST),
    mergeMap((action) => {
      Segment.trackEvent(ALERTS_PANEL_MARKED_ALL_READ);
      return from(NotificationHubApiService.markAllAsRead(action.priorityFilter)).pipe(
        mergeMap(() => of(markAllAsRead(action.priorityFilter))),
        catchError(() => EMPTY),
      );
    }),
  );
